export const DEBUG_ALLOWED_EMAILS = [
  'a.morin@legal2digital.fr',
  'n.larrieux@legal2digital.fr',
]

export const isDebugEmailAllowed = (email: string): boolean => {
  const normalized = email.trim().toLowerCase()
  if (!normalized) {
    return false
  }

  return DEBUG_ALLOWED_EMAILS.includes(normalized)
}
